import {
	Component,
	Input,
	OnInit,
	ViewChild,
	AfterViewInit,
	Output,
	EventEmitter,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ICON } from '@core/util/icon';
import { TestHooks } from './owners-table.hooks';
import { SearchPropertyOwner } from '@models/teranet';

@Component({
	selector: 'app-title-search-owners-table',
	templateUrl: './owners-table.component.html',
	styleUrls: ['./owners-table.component.scss'],
	standalone: false,
})
export class OwnersTableComponent implements OnInit, AfterViewInit {
	testHooks = TestHooks;
	public _owners: SearchPropertyOwner[];
	public ICON = ICON;
	public selectedIndex = null;
	@ViewChild(MatSort) sort: MatSort;
	@Input()
	set owners(_owners: SearchPropertyOwner[]) {
		this._owners = _owners;
		this.dataSource = new MatTableDataSource(_owners);
	}

	@Output() onSelectOwner = new EventEmitter<{
		first_name: string;
		last_name: string;
	}>();

	public dataSource;
	public displayedColumns: string[] = ['firstName', 'lastName'];

	constructor() {}

	ngAfterViewInit(): void {
		this.dataSource.sort = this.sort;
	}

	ngOnInit(): void {
		if (this._owners) {
			this.selectedIndex = 0;
		}
	}

	applyFilter = (filterValue: string): void => {
		filterValue = filterValue.trim();
		filterValue = filterValue.toLowerCase();
		this.dataSource.filter = filterValue;
	};

	trackByUid = (index) => index;

	selectName(owner: SearchPropertyOwner, index) {
		this.selectedIndex = index;
		this.onSelectOwner.emit(owner);
	}
}
